class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    
    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');
    // $('body').addClass('custom_overflow');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    // $('body').removeClass('custom_overflow');

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
      this.productId = parsedState.id;
      this.getSectionsToRender().forEach((section => {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));

      if (this.header) this.header.reveal();
      this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
//         selector: `#cart-notification-product-${this.productId}`,
        selector: `#cart-custom-notification`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);


// cd code
$(document).on("click", '.custom_cart_noti_pro_content .cutom_pro_remove span', function(){
  var quantity = 0;
  var id = $(this).attr('data-id');
  update(id, quantity);
  $('.custom_overlay_spinner').css("display", "flex");
});

$(document).on("change", '.custom_cart_noti_pro_content .custom_pro_qty .custom_pro_qty_selector', function(){
  var quantity = $(this).val();
  var id = $(this).attr('data-id');
  update(id, quantity);
  $('.custom_overlay_spinner').css("display", "flex");
});

// Grid Add To Cart
$(document).on('click', '.grid-addtocart-form button.addtocart', function() {
  var form_serialize = $( this ).parent('form').serialize();
  $.ajax({
    url: '/cart/add.js',
    type: 'POST',
    dataType: 'json',
    data: form_serialize,
    success:function(items) {
      if($('body').data('gwp-enabled') == true){
       	checkAddon();
      }
      changecart();
      $.getJSON('/cart.js',function(cart){
        $(".cart-count-bubble span:not(.visually-hidden)").html(cart.item_count);
        if(!$('.header .header__icon--cart .cart-count-bubble').length){
          $('.header .header__icon--cart').append('<div class="cart-count-bubble"><span aria-hidden="true">'+ cart.item_count +'</span><span class="visually-hidden">'+ cart.item_count +' item</span></div>');
        }
      });
      $('.cart-notification.custom_cart_drawer').addClass('active');
      // $('body').addClass('custom_overflow');
      $('.cart-notification.custom_cart_drawer .cart-notification-product').css('height', 'calc( 100vh - 370px )');
      $('.product_grid_size_popup').css("display", "none");
    }
  });
});

function update( id, quantity){
  $.ajax({
    url: '/cart/change.js',
    type: 'POST',
    dataType: 'json',
    data: {
      id: id,
      quantity: quantity
    },
    success:function(items) {
      if($('body').data('gwp-enabled') == true){
        checkAddon();
      }
      changecart();
      $.getJSON('/cart.js',function(cart){
        $(".cart-count-bubble span:not(.visually-hidden)").html(cart.item_count);
      });
    }
  });
}

function checkAddon(){
  $.ajax({
    url: '/cart.js',
    dataType: "json",
    async: false,
    cache: false,
    success: function(cart) {
      var variantId = Number($('span[data-freep]').attr('data-freep'));
      var variantId1 = Number($('span[data-freep1]').attr('data-freep1'));
      var variantId2 = Number($('span[data-freep2]').attr('data-freep2'));
      var variantId3 = Number($('span[data-freep3]').attr('data-freep3'));
      var variantId200_first = Number($('span[data-200-first]').attr('data-200-first'));
      var variantId200_second = Number($('span[data-200-second]').attr('data-200-second'));

      $.getJSON("/cart.js", function(cart) {
      var items = cart.items;
      var currentVarId,currentVarId1,currentVarId2,currentVarId3,currentVarId200;
      var quantity,quantity1,quantity2,quantity3,quantity200;
      var subtotal = cart.items_subtotal_price;
      var isProduct = false;
      var isProduct1 = false;
      var isProduct2 = false;
      var isProduct3 = false;
      var isProduct200 = false;
      
      var q = 0;
      var q1 = 0;
      var q2 = 0;
      var q3 = 0;
      var q200_first = 0;
      var q200_second = 0;

      var isGiftPrice = 0;
      var isGiftQty = 0;
      var totalItem = cart.item_count;  

      items.forEach(function(e,i,a){
        if(e.handle == 'coco-moon-gift-card' || e.handle == '50-sticker-pack' || e.handle == '150-mele-kalikimaka-milestone-card' || e.handle == '200-pacific-hues-security-blanket'){
          isGiftQty = isGiftQty + e.quantity;
          isGiftPrice = e.final_line_price;
        }
      });

      if(totalItem == isGiftQty){
        subtotal -= isGiftPrice;  
      }

      items.forEach(function(e,i,a){
        currentVarId = e.variant_id;
        if(currentVarId === variantId) {
          isProduct = true;
          quantity = e.quantity;
          return false;
        }
      });


      if(isProduct){
        items.forEach(function(e,i,a){
          var cv = e.variant_id;
          if(cv == variantId){
            q = q + e.quantity;
          }
        });
      }

       if(q > 1){
         $.ajax({
           url: '/cart/change.js',
           dataType: 'json',
           type: 'post',
           async: false,
           data: { quantity: 0, id: variantId },
           success: function (data) {}
         });
       }
        
        /* Free product over 50 */
        
        if(!isProduct) {
          if(subtotal >= 5000){
            $.ajax({
              url: '/cart/add.js',
              dataType: 'json',
              type: 'post',
              async: false,
              data: { quantity: 1, id: variantId },
              success: function (data) {}
            });
          }
        } else {
          if(subtotal >= 5000){
            if(quantity > 1) {
              $.ajax({
                url: '/cart/change.js',
                dataType: 'json',
                type: 'post',
                async: false,
                data: { quantity: 1, id: variantId },
                success: function (data) {}
              });
            }
          }
          else{
            $.ajax({
              url: '/cart/change.js',
              dataType: 'json',
              type: 'post',
              async: false,
              data: { quantity: 0, id: variantId },
              success: function (data) {}
            });
          }
        }
        /* End Free product over 50 */
        /* Free product over 150 */
        items.forEach(function(e,i,a){
          currentVarId1 = e.variant_id;
          if(currentVarId1 === variantId1) {
            isProduct1 = true;
            quantity1 = e.quantity;
            return false;
          }
        });
        if(isProduct1){
          items.forEach(function(e,i,a){
            var cv = e.variant_id;
            if(cv == variantId1){
              q1 = q1 + e.quantity;
            }
          });
        }
        if(q1 > 1){
          $.ajax({
            url: '/cart/change.js',
            dataType: 'json',
            type: 'post',
            async: false,
            data: { quantity: 0, id: variantId1 },
            success: function (data) {}
          });
        }

        if(!isProduct1) {
          if(subtotal >= 15000){
            $.ajax({
              url: '/cart/add.js',
              dataType: 'json',
              type: 'post',
              async: false,
              data: { quantity: 1, id: variantId1 },
              success: function (data) {}
            });
          }
        } else {
          if(subtotal >= 15000){
            if(quantity1 > 1) {
              $.ajax({
                url: '/cart/change.js',
                dataType: 'json',
                type: 'post',
                async: false,
                data: { quantity: 1, id: variantId1 },
                success: function (data) {}
              });
            }
          }
          else{
            $.ajax({
              url: '/cart/change.js',
              dataType: 'json',
              type: 'post',
              async: false,
              data: { quantity: 0, id: variantId1 },
              success: function (data) {}
            });
          }
        }
        /* End Free product over 150 */

        /* Free product over 200 */
            items.forEach(function(e,i,a){
              currentVarId200 = e.variant_id;
              if(currentVarId200 === variantId200_first) {
                isProduct200 = true;
                q200_first = e.quantity;
                return false;
              }
              if(currentVarId200 === variantId200_second) {
                isProduct200 = true;
                q200_second = e.quantity;
                return false;
              }
            });
           
            if(q200_first > 1){
              $.ajax({
                url: '/cart/change.js',
                dataType: 'json',
                type: 'post',
                async: false,
                data: { quantity: 0, id: variantId200_first },
                success: function (data) {}
              });
            }
            if(q200_second > 1){
                $.ajax({
                  url: '/cart/change.js',
                  dataType: 'json',
                  type: 'post',
                  async: false,
                  data: { quantity: 0, id: variantId200_second },
                  success: function (data) {}
                });
              }

            if(!isProduct200) {
              if(subtotal >= 20000){
                $('.product_gwp_popup').css("display", "flex");
              }
            } else {
              if(subtotal >= 20000){
                if(q200_first > 1) {
                  $.ajax({
                    url: '/cart/change.js',
                    dataType: 'json',
                    type: 'post',
                    async: false,
                    data: { quantity: 1, id: variantId200_first },
                    success: function (data) {}
                  });
                }
                if(q200_second > 1) {
                  $.ajax({
                    url: '/cart/change.js',
                    dataType: 'json',
                    type: 'post',
                    async: false,
                    data: { quantity: 1, id: variantId200_second },
                    success: function (data) {}
                  });
                }
              }else{
                if(q200_first > 0) {
                  $.ajax({
                    url: '/cart/change.js',
                    dataType: 'json',
                    type: 'post',
                    async: false,
                    data: { quantity: 0, id: variantId200_first },
                    success: function (data) {}
                  });
                }
                if(q200_second > 0) {
                  $.ajax({
                    url: '/cart/change.js',
                    dataType: 'json',
                    type: 'post',
                    async: false,
                    data: { quantity: 0, id: variantId200_second },
                    success: function (data) {}
                  });
                }
              }
            }
            /* End Free product over 200 */
        
         /* Free product over 300 */
        items.forEach(function(e,i,a){
          currentVarId2 = e.variant_id;
          if(currentVarId2 === variantId2) {
            isProduct2 = true;
            quantity2 = e.quantity;
            return false;
          }
        });
        if(isProduct2){
          items.forEach(function(e,i,a){
            var cv = e.variant_id;
            if(cv == variantId2){
              q2 = q2 + e.quantity;
            }
          });
        }
        if(q2 > 1){
          $.ajax({
            url: '/cart/change.js',
            dataType: 'json',
            type: 'post',
            async: false,
            data: { quantity: 0, id: variantId2 },
            success: function (data) {}
          });
        }

        if(!isProduct2) {
          if(subtotal >= 30000){
            $.ajax({
              url: '/cart/add.js',
              dataType: 'json',
              type: 'post',
              async: false,
              data: { quantity: 1, id: variantId2 },
              success: function (data) {}
            });
          }
        } else {
          if(subtotal >= 30000){
            if(quantity2 > 1) {
              $.ajax({
                url: '/cart/change.js',
                dataType: 'json',
                type: 'post',
                async: false,
                data: { quantity: 1, id: variantId2 },
                success: function (data) {}
              });
            }
          }
        }
        /* End Free product over 300 */

       /* Free product over 500 */
        items.forEach(function(e,i,a){
          currentVarId3 = e.variant_id;
          if(currentVarId3 === variantId3) {
            isProduct3 = true;
            quantity3 = e.quantity;
            return false;
          }
        });
        if(isProduct3){
          items.forEach(function(e,i,a){
            var cv = e.variant_id;
            if(cv == variantId3){
              q3 = q3 + e.quantity;
            }
          });
        }
        if(q3 > 1){
          $.ajax({
            url: '/cart/change.js',
            dataType: 'json',
            type: 'post',
            async: false,
            data: { quantity: 0, id: variantId3 },
            success: function (data) {}
          });
        }

        if(!isProduct3) {
          if(subtotal >= 50000){
            $.ajax({
              url: '/cart/add.js',
              dataType: 'json',
              type: 'post',
              async: false,
              data: { quantity: 1, id: variantId3 },
              success: function (data) {}
            });
          }
        } else {
          if(subtotal >= 50000){
            if(quantity3 > 1) {
              $.ajax({
                url: '/cart/change.js',
                dataType: 'json',
                type: 'post',
                async: false,
                data: { quantity: 1, id: variantId3 },
                success: function (data) {}
              });
            }
          }
        }
        /* End Free product over 500 */
      
       });   

      }
    });
}

function changecart(){
  $.ajax({
    url: '/?section_id=cart-notification-product',
    type: 'GET',
    dataType: 'html',
    success:function(carthtml) {
      $("#cart-notification-product").html(carthtml);
      $('.custom_overlay_spinner').css("display", "none");
      $('.custom_cart_drawer_empty').parents('#cart-notification-product').css("height", "unset")
    }
  });
}

$(document).ready(function(){
  changecart()
});